<!-- MasterBookの利用規約表示 -->
<template>
  <div class="column-body">
    <!-- チケット規約約款 -->
    <div class="buttons">
      <a class="button" @click="goToExternalTerms(url)">
        {{ $t("common.terms") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "MbTermsUrl",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column-body {
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #ffb206;
  margin-bottom: 10px;
}

.button {
  display: block;
  border-radius: 4px;
  padding: 15px;
  padding-right: 30px;
  font-size: 14px;
  font-weight: bold;
  background-color: #fae278;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  background-image: url("~@/assets/img//arrow/svg/arow-right-black.svg");
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
  background-size: 8px;
  color: #000000;
  border-radius: 10px;
}

.button:hover,
.button:active,
.button:focus {
  text-decoration: none;
}
</style>
